"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTableRow = exports.renderTableHeads = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var format_1 = require("@/utils/format");
exports.renderTableHeads = function (props) {
    var getHeaderFields = function (props) {
        var nameValue = (React.createElement("div", null,
            React.createElement("div", { className: "u-mobile-hidden" }, props.t.place),
            React.createElement("div", { className: "u-mobile-only" }, props.t.place)));
        var priceValue = (React.createElement("div", null,
            React.createElement("div", { className: "u-mobile-hidden" }, props.t.price),
            React.createElement("div", { className: "u-mobile-only" }, props.t.price)));
        var ppsfValue = (React.createElement("div", null,
            React.createElement("div", { className: "u-mobile-hidden" }, props.t.pricePerSqft),
            React.createElement("div", { className: "u-mobile-only" }, props.t.pricePerSqftAbr)));
        var sizeValue = (React.createElement("div", null,
            React.createElement("div", { className: "u-mobile-hidden" }, props.t.size),
            React.createElement("div", { className: "u-mobile-only" }, props.t.size)));
        var bedValue = React.createElement("div", null, props.t.bed);
        var bathValue = React.createElement("div", null, props.t.bath);
        // Determine which sort field should be used for Price and Price/psf columns
        var availablePriceSortType = props.filterType === SfilterTypeGroup_1.SfilterType.RENT
            ? PlaceState_1.AvailableSortType.LEASE_PRICE
            : PlaceState_1.AvailableSortType.SALE_PRICE;
        var availablePpsfSortType = props.filterType === SfilterTypeGroup_1.SfilterType.RENT
            ? PlaceState_1.AvailableSortType.LEASE_PRICE_PER_SQFT
            : PlaceState_1.AvailableSortType.SALE_PRICE_PER_SQFT;
        var headerFields = [
            null,
            null,
            {
                value: priceValue,
                type: availablePriceSortType,
                caret: true,
            },
            {
                value: ppsfValue,
                type: availablePpsfSortType,
                caret: true,
            },
            {
                value: sizeValue,
                type: PlaceState_1.AvailableSortType.NET_SIZE,
                caret: true,
            },
            {
                value: bedValue,
                type: PlaceState_1.AvailableSortType.BED,
                caret: true,
            },
            {
                value: bathValue,
                type: PlaceState_1.AvailableSortType.BATH,
                caret: true,
            },
            null,
        ];
        if (props.availableShowBuildingName) {
            headerFields.splice(2, 0, {
                value: nameValue,
                type: PlaceState_1.AvailableSortType.NAME,
                caret: true,
            });
            headerFields.splice(5, 1);
        }
        return headerFields;
    };
    var headerFields = getHeaderFields(props);
    var toggleOrder = function (type) { return function () {
        return props.toggleSort(type, props.filterType);
    }; };
    var availableSort = props.currentSort;
    var fieldHeadClass = function (type) {
        return classnames_1.default([
            "c-tableview__tcell",
            {
                "c-tableview__tcell--active": availableSort === type,
                "c-tableview__tcell--sortable": availableSort !== type,
            },
        ]);
    };
    var renderTableHead = function (it, i) {
        if (!it)
            return React.createElement("td", { key: i, className: "c-tableview__tcell" });
        var divAttr = {
            onClick: it.type ? toggleOrder(it.type) : function () { },
            className: it.type ? fieldHeadClass(it.type) : "c-tableview__tcell",
        };
        return (React.createElement("td", __assign({ key: i }, divAttr),
            React.createElement("div", { style: { width: "100%", display: "flex", alignItems: "center" } },
                it.value,
                it.caret ? React.createElement("span", { className: "c-tableview__tcaret" }) : "",
                it.caret ? React.createElement("span", { className: "c-tableview__tsort" }) : "")));
    };
    return (React.createElement("tr", { className: "c-tableview__trow c-tableview__trow--head" }, headerFields.map(renderTableHead)));
};
exports.renderTableRow = function (props, item, index) {
    var bedFields = item.amenities.filter(function (it) { return it.key === "bed"; });
    var bathFields = item.amenities.filter(function (it) { return it.key === "bath"; });
    var beds = bedFields.length ? bedFields[0].value : -1;
    var baths = bathFields.length ? bathFields[0].value : -1;
    var netsize = item.sizeSaleable;
    var grosssize = item.sizeGross;
    // tslint:disable-next-line:max-line-length
    var propertyLink = propertyToUrl_1.propertyToUrl(props.lang, item.building, item.referenceId, item.type);
    var rowClicked = function () {
        props.propertyLinkClicked(propertyLink);
    };
    var favClicked = function (e) {
        e.stopPropagation();
        props.favClicked(item);
    };
    var currencyCode = props.currencyCode;
    var price = props.filterType === SfilterTypeGroup_1.SfilterType.BUY ? item.salePrice : item.leasePrice;
    var ppsf = props.filterType === SfilterTypeGroup_1.SfilterType.BUY
        ? item.salePricePerSqft
        : item.leasePricePerSqft;
    var getTableCells = function (props, item) {
        var renderGrossSize = function (props, grossSize) {
            if (!grossSize)
                return "";
            return (React.createElement("div", null,
                React.createElement("div", { className: "u-mobile-hidden" },
                    React.createElement("span", { className: "c-tableview__smtext" },
                        format_1.default.comma(grosssize),
                        " ",
                        props.t.grossAbr)),
                React.createElement("div", { className: "u-mobile-only" },
                    React.createElement("span", { className: "c-tableview__smtext" },
                        format_1.default.comma(grosssize),
                        " ",
                        props.t.grossAbr))));
        };
        var renderNetSize = function (props, netSize) {
            if (!netSize)
                return "";
            return (React.createElement("div", null,
                React.createElement("div", { className: "u-mobile-hidden" },
                    format_1.default.comma(netSize),
                    "\u00A0 ",
                    props.t.netAbr),
                React.createElement("div", { className: "u-mobile-only" },
                    React.createElement("span", { className: "c-tableview__smtext" }, format_1.default.comma(netSize)))));
        };
        var ppsfMarkup;
        if (!ppsf) {
            ppsfMarkup = "-";
        }
        else {
            ppsfMarkup = React.createElement("div", null,
                " ",
                format_1.default.currencyPpsf(ppsf, props.symbol));
        }
        var renderPrice = function (item, prefix) {
            if (price <= 0 || item.isSubjectToOffer) {
                return props.t.subjectToOffer;
            }
            return props.filterType === SfilterTypeGroup_1.SfilterType.BUY
                ? format_1.default.currencySale(price, props.lang, prefix + " ")
                : format_1.default.currencyLease(price, props.lang, prefix + " ");
        };
        var renderInc = function (item) {
            if (props.filterType !== SfilterTypeGroup_1.SfilterType.RENT)
                return null;
            if (item.includeManagementFee === ResultPageState_1.ResultIncludeManagementFee.INCLUDE) {
                return React.createElement("span", { className: "price__incl" }, "Incl.");
            }
            if (item.includeManagementFee === ResultPageState_1.ResultIncludeManagementFee.EXCLUDE) {
                return React.createElement("span", { className: "price__incl" }, "Excl.");
            }
            return null;
        };
        var renderFavIcon = function (props, isSaved) {
            if (!isSaved) {
                return React.createElement("span", { className: "fal fa-heart" });
            }
            return React.createElement("span", { className: "fas fa-heart" });
        };
        var renderImage = function (item, prefix) {
            var staticMap = "https://maps.googleapis.com/maps/api/staticmap?center=" + item.lat + "," + item.lng + "&zoom=16&size=300x200&markers=color:0x00b0a8|" + item.lat + "," + item.lng + "&maptype=roadmap&style=feature:all|element:labels&key=" + props.googleApikey;
            var altText = item.building;
            var priceAlText = renderPrice(item, prefix);
            var imgAttr = {
                alt: altText + " - " + (item.type === SfilterTypeGroup_1.SfilterType.RENT ? props.t.forRent : props.t.forRent) + (netsize ? " - " + netsize + " " + props.t.sqft : "") + " - " + priceAlText + " - #" + item.referenceId,
            };
            return item.images.length && item.images[0].path ? (React.createElement("img", __assign({}, imgAttr, { "data-src": item.images[0].path, src: item.images[0].path, loading: "lazy" }))) : item.lat ? (React.createElement("img", __assign({}, imgAttr, { src: staticMap }))) : (React.createElement("img", { src: "/res/img/nopic.jpg" }));
        };
        var onRowContactClicked = function (event) {
            event.stopPropagation();
            props.propertyEnquireClicked(item);
        };
        var tableRows = [
            React.createElement("td", { key: 0, className: "c-tableview__tcell" },
                React.createElement("div", null, renderImage(item, currencyCode))),
            React.createElement("td", { key: 9, className: "c-tableview__tcell u-flex u-flex--middle", onClick: favClicked }, renderFavIcon(props, item.isSaved)),
            React.createElement("td", { key: 2, className: "c-tableview__tcell" },
                React.createElement("div", { className: "u-mobile-hidden" },
                    renderPrice(item, props.symbol),
                    " ",
                    renderInc(item)),
                React.createElement("div", { className: "u-mobile-only" },
                    React.createElement("div", { className: "u-underline" },
                        renderPrice(item, ""),
                        " ",
                        renderInc(item)))),
            React.createElement("td", { key: 3, className: "c-tableview__tcell" }, ppsfMarkup),
            React.createElement("td", { key: 4, className: "c-tableview__tcell" },
                netsize ? renderNetSize(props, netsize) : "-",
                grosssize ? renderGrossSize(props, grosssize) : ""),
            React.createElement("td", { key: 5, className: "c-tableview__tcell" }, beds > -1 ? beds : "-"),
            React.createElement("td", { key: 6, className: "c-tableview__tcell" }, baths > -1 ? baths : "-"),
            React.createElement("td", { key: 8, className: "c-tableview__tcell c-tableview__tcell--center u-mobile-hidden" },
                React.createElement("button", { className: "c-tableview__contact", onClick: onRowContactClicked },
                    React.createElement("span", { className: "fal fa-envelope" }),
                    "\u00A0",
                    props.t.contactAgent)),
        ];
        if (props.availableShowBuildingName) {
            tableRows.splice(2, 0, React.createElement("td", { key: 10, className: "c-tableview__tcell" },
                React.createElement("a", { href: propertyLink }, item.building)));
            tableRows.splice(5, 1);
        }
        return tableRows;
    };
    return (React.createElement("tr", { key: index, onClick: rowClicked, className: "c-tableview__trow" }, getTableCells(props, item)));
};
